import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { OfferPageComponent } from './components/offer-page/offer-page.component';
import { OfferComponent } from './offer.component';

const routes: Routes = [
  {
    path: '',
    component: OfferComponent,
    children: [
      {
        path: '',
        component: OfferPageComponent,
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class OfferRoutingModule {}
